import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {Props} from "../types";

const LANG_NL = 'nl_NL'

export const Questions = (props: Props.Questions) => {

    const [activeQuestion, setActiveQuestion] = React.useState<number>(0);
    const [activeExplanation, setActiveExplanation] = React.useState<number | null>(null);

    const newItems = props.data.items.filter(item => {
        return item !== null
    })

    const showTranslation = (nl: string, en: string) => {
        return props.data.language === LANG_NL ? nl : en;
    }

    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current && activeExplanation !== null) {
            contentRef.current.innerHTML = `${newItems[activeExplanation].rendered_content}`
        }
    }, [activeExplanation])

    useEffect(() => {
        if (newItems.length === activeQuestion + 1) {
            setActiveExplanation(activeQuestion)
        }
    }, [activeQuestion])

    const setYesAnswer = () => {
        if (newItems[activeQuestion].default_yes) {
            setActiveQuestion(prevQuestion => prevQuestion + 1)
            setActiveExplanation(null)
        } else {
            setActiveExplanation(activeQuestion)
        }
    }

    const setNoAnswer = () => {
        if (newItems[activeQuestion].default_yes) {
            setActiveExplanation(activeQuestion)
        } else {
            setActiveQuestion(prevQuestion => prevQuestion + 1)
            setActiveExplanation(null)
        }
    }

    if (activeQuestion === newItems.length) {
        return (
            <div className={'c-funnel-guide-not-exist'}>
                <h4>{showTranslation('Er zijn geen vragen meer','No more questions')}</h4>
                <button className={'o-button__text'} onClick={() => {
                    setActiveExplanation(null)
                    setActiveQuestion(0)
                }}>{showTranslation('Opnieuw beginnen','Restart funnelguide')}
                </button>
            </div>
        )
    }

    return (
        <div className={'o-container o-block c-funnel-guide-question-container'}>
            <div className={'c-funnel-guide-question-header-container'}>
                <div className={'c-funnel-guide-question-header'}>
                    <h4>{props.data.title}</h4>
                    <p>{props.data.description}</p>
                </div>
                <button className={'c-funnel-guide__restart'} onClick={() => {
                    setActiveExplanation(null)
                    setActiveQuestion(0)
                }}>{showTranslation('opnieuw beginnen','restart funnelguide')}
                </button>
            </div>

            {activeQuestion !== null && newItems.length > 0 && (
                <div className={'c-funnel-guide-question-item'}>
                    <h4>{newItems[activeQuestion].post_title}</h4>
                </div>
            )}

            {activeExplanation !== null && (
                <div className={'c-funnel-guide-explanation c-generic-block  s-wordpress'}>
                    <div ref={contentRef}/>
                </div>)}

            {newItems.length > activeQuestion + 1 && activeExplanation !== activeQuestion && (
                <div className={'c-funnel-guide-question-btn'}>

                    <label className="c-quickscan__answer" role="button"><input checked={false} type={'radio'}
                                                                                className={'o-button__text c-quickscan__answer__input'}
                                                                                onChange={setYesAnswer}/><span
                        className="c-quickscan__answer__text">{showTranslation('Ja','Yes')}</span></label>

                    <label className="c-quickscan__answer" role="button"><input checked={false} type={'radio'}
                                                                                disabled={activeQuestion === activeExplanation}
                                                                                className={'o-button__text c-quickscan__answer__input'}
                                                                                onChange={setNoAnswer}/><span
                        className="c-quickscan__answer__text">{showTranslation('Nee','No')}</span></label>

                </div>
            )}
        </div>
    );
};
